<template>
  <nav class="main-nav">
    <button
        class="hamburger-btn"
        :class="{ 'active': menuOpen }"
        @click="toggleMenu"
    >
      <span></span>
      <span></span>
      <span></span>
    </button>

    <ul class="nav-menu" :class="{ 'is-active': menuOpen }">
      <li><router-link to="/" @click="closeMenu" exact>Acasă</router-link></li>
      <li><router-link to="/psihologi" @click="closeMenu">Psihologi</router-link></li>
      <li><router-link to="/probono" @click="closeMenu">ProBono</router-link></li>
      <li><router-link to="/contact" @click="closeMenu">Contact</router-link></li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'NavigationComponent',
  data () {
    return {
      menuOpen: false
    }
  },
  methods: {
    toggleMenu () {
      this.menuOpen = !this.menuOpen;
      // document.body.style.overflow = this.menuOpen ? 'hidden' : '';
    },
    closeMenu () {
      this.menuOpen = false;
      // document.body.style.overflow = '';
    }
  }
}
</script>

<style lang="scss">
  $primary-color: #263f7a;
  $white: white;
  $off-white: #fff;

  @media only screen and (min-width: 0px) {
    .main-nav {
      width: 100%;
      display: flex;
      position: relative;
      z-index: 10;
      justify-content: flex-end;

      .hamburger-btn {
        position: relative;
        display: block;
        width: 40px;
        height: 40px;
        background: transparent;
        border: none;
        cursor: pointer;
        padding: 0;
        z-index: 20;
        margin: 0;
        align-self: center;
        left: 10px;

        span {
          display: block;
          width: 24px;
          height: 2px;
          margin: 5px auto;
          background-color: $white;
          transition: all 0.3s ease;
        }

        &.active {
          span:nth-child(1) {
            transform: rotate(45deg) translate(5px, 5px);
          }

          span:nth-child(2) {
            opacity: 0;
          }

          span:nth-child(3) {
            transform: rotate(-45deg) translate(5px, -5px);
          }
        }
      }

      .nav-menu {
        position: fixed;
        top: 0;
        right: -100%;
        width: 100%;
        height: 100vh;
        background-color: $primary-color;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        transition: right 0.4s ease;
        z-index: 10;
        padding: 0;

        &.is-active {
          right: 0;
        }

        li {
          list-style: none;
          margin: 15px 0;
        }

        a {
          font-size: 24px;
          color: $white;
          text-decoration: none;
          padding: 10px;
          transition: color 0.3s;
          display: inline-block;

          &:hover {
            font-weight: bold;
            color: $off-white;
          }

          &.router-link-active {
            font-weight: bold;
            color: $off-white;
          }
        }
      }
    }

    @media only screen and (min-width: 768px) {
      .main-nav {
        position: static;
        padding: 0;
        justify-content: flex-end;

        .hamburger-btn {
          display: none;
        }

        .nav-menu {
          position: static;
          height: auto;
          width: auto;
          background: transparent;
          flex-direction: row;
          justify-content: flex-end;
          margin: 0;

          li {
            margin: 0 0 0 30px;
            padding: 0;

            &:first-child {
              margin-left: 0;
            }
          }

          a {
            font-size: 18px;
            padding: 5px 0;
            margin: 0;

            &.router-link-active,
            &.router-link-exact-active {
              font-weight: bold;
            }
          }
        }
      }
    }
  }
</style>